// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Permission Elevation API
 * API for engineers to elevate and de-elevate their permissions within Aura.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const EnumAccessType = {
  AccessTypeProduction: 'production',
  AccessTypeAdmin: 'admin',
  AccessTypePlatformAdmin: 'platformAdmin',
} as const;
export type EnumAccessType =
  (typeof EnumAccessType)[keyof typeof EnumAccessType];

export function instanceOfEnumAccessType(value: any): boolean {
  for (const key in EnumAccessType) {
    if (Object.prototype.hasOwnProperty.call(EnumAccessType, key)) {
      if (EnumAccessType[key as keyof typeof EnumAccessType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function EnumAccessTypeFromJSON(json: any): EnumAccessType {
  return EnumAccessTypeFromJSONTyped(json, false);
}

export function EnumAccessTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnumAccessType {
  return json as EnumAccessType;
}

export function EnumAccessTypeToJSON(value?: EnumAccessType | null): any {
  return value as any;
}

export function EnumAccessTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): EnumAccessType {
  return value as EnumAccessType;
}
